/**
*Created by jmmartinez on 13/09/21
 * v.1.1 29/10/2024  Añadida la propiedad backgroundColor
 * v.1.2 03/06/2026  Modificaciones para leer correctamente HTML y representarlo.
 *                   Añadida la opción del color de letra y de fondo.
 */

import React from 'react'
import PropTypes from 'prop-types';
import ReactQuill, { Quill }  from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.core.css';

// ✅ Registrar explícitamente los blots de color y background
const ColorClass = Quill.import('attributors/class/color');
const BackgroundClass = Quill.import('attributors/class/background');
const ColorStyle = Quill.import('attributors/style/color');
const BackgroundStyle = Quill.import('attributors/style/background');

Quill.register(ColorClass, true);
Quill.register(BackgroundClass, true);
Quill.register(ColorStyle, true);
Quill.register(BackgroundStyle, true);


class HTMLEditorQuill extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            texto: props.texto,
            htmlCargado: false
        }
        console.log("CONSTRUCTOR: ", props);
        this.quillRef = React.createRef();
    }

    componentDidMount() {
        this._cargarHTMLinicial(this.props.texto);
    }


    componentDidUpdate(prevProps) {
        // Si cambia el texto desde fuera y aún no lo hemos cargado (o es un reset)
        if (prevProps.texto !== this.props.texto && !this.state.htmlCargado) {
            this._cargarHTMLinicial(this.props.texto);
        }
    }

    _normalizarHTML = (html) => {
        if (!html) return html;

        // Paso 1: todo a minúsculas excepto valores entre comillas
        let resultado = '';
        let dentroComillas = false;
        let tipoComilla = '';

        for (let i = 0; i < html.length; i++) {
            const char = html[i];
            if (!dentroComillas && (char === '"' || char === "'")) {
                dentroComillas = true;
                tipoComilla = char;
                resultado += char;
            } else if (dentroComillas && char === tipoComilla) {
                dentroComillas = false;
                resultado += char;
            } else if (!dentroComillas) {
                resultado += char.toLowerCase();
            } else {
                resultado += char;
            }
        }

        // Paso 2: dentro de style="...", normalizar los NOMBRES de propiedad CSS
        // Los valores (RGB, colores, etc.) se dejan como están
        resultado = resultado.replace(/style="([^"]*)"/g, (_, cssContent) => {
            // Cada declaración: "PROPIEDAD: valor"
            // Solo ponemos en minúscula la parte antes del ":"
            const cssNorm = cssContent.replace(/([^:;]+)(:)/g, (_, prop, colon) => {
                return prop.toLowerCase() + colon;
            });
            return `style="${cssNorm}"`;
        });

        return resultado;
    }

    _cargarHTMLinicial = (html) => {
        //console.log('_cargarHTMLinicial');
        //console.log('html: ', html);

        if (!html || this.state.htmlCargado)
            return;

        const editor = this.quillRef.current?.getEditor();
        if (!editor)
            return;
        //console.log('editor: ', editor);

        // ✅ Normalizar antes de insertar
        // Tenemos que poner en minusculas.
        const htmlNormalizado = this._normalizarHTML(html);
        console.log('HTML normalizado:', htmlNormalizado);

        // ✅ dangerouslyPasteHTML respeta estilos inline, colores, etc.
        editor.clipboard.dangerouslyPasteHTML(0, htmlNormalizado);

        this.setState({ htmlCargado: true});
    }

    changeTexto= (newTexto) => {
           const{onChange} = this.props;
        //console.log("***changeTexto: ", newTexto);
        this.setState({ texto: newTexto }, () => {
            onChange && onChange(newTexto);
        })
    }



    render() {
        const {height, backgroundColor} = this.props;

        let toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{
                'color': [
                    '#000000', '#e60000', '#ff9900', '#ffff00',
                    '#008a00', '#0066cc', '#9933ff', '#ffffff',
                    '#facccc', '#ffebcc', '#ffffcc', '#cce8cc',
                    '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666',
                    '#ffc266', '#ffff66', '#66b966', '#66a3e0',
                    '#c285ff', '#888888', '#a10000', '#b26b00',
                    '#b2b200', '#006100', '#0047b2', '#6b24b2',
                    '#444444', '#5c0000', '#663d00', '#666600',
                    '#003700', '#002966', '#3d1466', 'custom-color'
                ]
            },
                {
                    'background': [
                        '#000000', '#e60000', '#ff9900', '#ffff00',
                        '#008a00', '#0066cc', '#9933ff', '#ffffff',
                        '#facccc', '#ffebcc', '#ffffcc', '#cce8cc',
                        '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666',
                        '#ffc266', '#ffff66', '#66b966', '#66a3e0',
                        '#c285ff', '#888888', '#a10000', '#b26b00',
                        '#b2b200', '#006100', '#0047b2', '#6b24b2',
                        '#444444', '#5c0000', '#663d00', '#666600',
                        '#003700', '#002966', '#3d1466', 'custom-color'
                    ]
                }],
            //[{ 'font': [] }],
            //[{ 'align': [] }],
            //['link', 'image'],
            ['clean']                                         // remove formatting button
        ];

        let heightDIV= height + "px";
        let heightHTMLEditor= (height - 50) + "px";

        const formats = [
            'bold', 'italic', 'underline', 'strike', // <- estos dos son los que te fallaban
            'blockquote', 'code-block',
            'header', 'list', 'bullet',
            'script', 'indent', 'direction', 'size',
            'color', 'background', 'font', 'align',
            'link', 'image',
            "table", "row","column",// Agregas soporte para tablas
        ];



        return (
            <div style={{height: heightDIV, backgroundColor: backgroundColor}}>
                <ReactQuill ref={this.quillRef}
                            onChange={this.changeTexto}
                            modules={{toolbar: toolbarOptions}}
                            style={{height: heightHTMLEditor}}
                            formats={formats}
                            theme="snow"
                            // ✅ NO pasamos value aquí para evitar que Quill re-parsee el HTML
                            //    en cada render y lo aplaste. El contenido lo cargamos via ref.
                />
            </div>
        )
    }

}


HTMLEditorQuill.propTypes = {
    texto: PropTypes.string,
    onChange: PropTypes.func,
    height: PropTypes.number,
    backgroundColor: PropTypes.string,
}

export default HTMLEditorQuill;